import state from "./state";

const getters = Object.keys(state).reduce((getters, key) => {
    getters[key] = (state) => state[key];
    return getters;
}, {});

const customGetter = {
    ...getters,
    imageStore() {
        return "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/wa_autosender/status/";
        // return process.env.NODE_ENV !== "production"
        //     ? "https://storage.googleapis.com/"
        //     : "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/wa_autosender/status/";
    },
    dateFormated() {
        return (date, moment) => {
            if (date) {
                return moment(date).format("Do MMM YYYY HH:mm");
            } else {
                return "";
            }
        };
    },
    isVideo() {
        return (type) => {
            return type === 3;
        };
    },
    isImage() {
        return (type) => {
            return type === 2;
        };
    },
    isText() {
        return (type) => {
            return type === 1;
        };
    },
    isSchedulePost() {
        return (postDate, moment) => {
            return moment(postDate).format("Do MMM YYYY") !== "1 Jan 0001";
        };
    },
    isOntimePost() {
        return (postDate, moment) => {
            return moment(postDate).format("Do MMM YYYY") === "1 Jan 0001";
        };
    },
    isDailyPost() {
        return (day) => {
            return !!day;
        };
    },
    getTypeStatus() {
        return (status, type) => {
            if (type === 1) {
                switch (status) {
                    case 2:
                        return "Telah diposting";
                    case 3:
                        return "Gagal";
                    case 4:
                        return "Telah diakhiri";
                    case 1:
                        return "..Sedang tayang";
                }
            } else if (type === 2) {
                switch (status) {
                    // case 0:
                    // default:
                    //     return "Tidak aktif";
                }
            }
        };
    },
    getPopUpLink() {
        return (routeName) => {
            switch (routeName) {
                case "wa_status.list":
                    return {
                        tayang: "wa_status.sedang_tayang",
                        terjadwal: "wa_status.terjadwal",
                        diposting: "wa_status.diposting",
                        gagal: "wa_status.gagal_posting",
                    };
                case "wa_status.riwayat_status":
                    return {
                        tayang: "wa_status.riwayat_status.sedang_tayang",
                        terjadwal: "wa_status.riwayat_status.terjadwal",
                        diposting: "wa_status.riwayat_status.diposting",
                        gagal: "wa_status.riwayat_status.gagal_posting",
                    };
                case "wa_status.status_aktif":
                    return {
                        tayang: "wa_status.status_aktif.sedang_tayang",
                        gagal: "wa_status.status_aktif.gagal_posting",
                        terjadwal: "wa_status.status_aktif.terjadwal",
                        diposting: "wa_status.status_aktif.diposting",
                    };
            }
        };
    },
    getConfirmLink() {
        return (routeName) => {
            switch (routeName) {
                case "wa_status.sedang_tayang":
                    return {
                        endShow: "wa_status.confirm_akhiri_penayangan",
                    };
                case "wa_status.riwayat_status.sedang_tayang":
                    return {
                        endShow: "wa_status.riwayat_status.confirm_akhiri_penayangan",
                    };
                case "wa_status.status_aktif.sedang_tayang":
                    return {
                        endShow: "wa_status.status_aktif.confirm_akhiri_penayangan",
                    };
            }
        };
    },
    getConfirmDelete() {
        return (routeName) => {
            switch (routeName) {
                case "wa_status.terjadwal":
                    return "wa_status.confirm_hapus";
                case "wa_status.riwayat_status.terjadwal":
                    return "wa_status.riwayat_status.confirm_hapus";
                case "wa_status.status_aktif.terjadwal":
                    return "wa_status.status_aktif.confirm_hapus";
            }
        };
    },
};

export default customGetter;
